import { getDistance } from '@/util'
import _ from 'lodash'
export const getModelList = data => {
  let series = data.filter(item => item.parent === 0)
  let model = data.filter(item => item.parent !== 0)
  let result = series.map(item => {
    let text = item.name
    let value = item.value
    let currentModel = model.filter(subItem => value === subItem.parent)
    let children = currentModel.map(subItem => {
      return {
        text: subItem.name,
        value: subItem.value,
        parent: subItem.parent
      }
    })
    return {
      text,
      children
    }
  })
  let topOne = {
    text: '请选择车系',
    children: [
      {
        text: '请选择车型'
      }
    ]
  }
  result.unshift(topOne)
  return result
}

export const getAllTyreSizeList = async data => {
  if (!data) return
  let allList = await getAllList(data)
  let result = await sortTrySpec(allList)
  return result
}
export const getAllList = data => {
  return new Promise(resolve => {
    let arr = []
    let spc = []
    for (const i in data) {
      arr.push(...data[i])
    }
    for (const item of arr) {
      spc.push(item.value)
    }
    let allList = Array.from(new Set(spc))
    resolve(allList)
  })
}
export const sortTrySpec = data => {
  return new Promise((resolve, reject) => {
    if (!data) {
      reject([])
    }
    let result = []
    for (const item of data) {
      let one = Number(item.substring(0, 3))
      let two = Number(item.substring(4, 6))
      let three = Number(item.substring(7))
      result.push({
        one,
        two,
        three,
        value: item
      })
    }
    result = _.sortBy(result, ['one', 'two', 'three']).map(item => item.value)
    resolve(result)
  })
}
export const getTyreBrands = data => {
  if (!data) return
  let result = [
    {
      text: '请选择轮胎品牌',
      value: ''
    }
  ]
  for (const key in data) {
    if (Object.hasOwnProperty.call(data, key)) {
      result.push({
        text: data[key].name,
        value: data[key].value
      })
    }
  }
  return result
}

export const getTyreDealer = data => {
  let result = data?.map(item => {
    item.dealer.distance = getDistance(item.dealer.distance)
    let newData = {
      // dealer_stock :店内库存  stock :物流库存  two_hours_stock :极速订单库存  next_day_stock :普通订单库存
      dealer_stock: item.dealer_stock,
      next_day_stock: item.next_day_stock,
      two_hours_stock: item.two_hours_stock,
      stock: item.stock,
      allStock: item.dealer_stock + item.stock, //最大供货数量all_stock
      ...item.dealer
    }
    return newData || []
  })
  return result
}
export const getBrandsforSpec = (data, n) => {
  let result = [
    {
      text: '请选择轮胎品牌',
      value: ''
    }
  ]
  // console.log(data, n)
  let brand = data.tyre_brands
  if (n) {
    let getSpec = data.spec_brands[n]
    for (const key in brand) {
      if (getSpec.indexOf(key) >= 0) {
        let { name, value } = brand[key]
        result.push({
          text: name,
          value
        })
      }
    }
  } else {
    for (const key in brand) {
      let { name, value } = brand[key]
      result.push({
        text: name,
        value
      })
    }
  }

  return result
}

export const sortArr = data => {
  let list = []
  for (let key in data) {
    list.push({
      rightTypeFlag: data[key][0].rightTypeFlag,
      num: data[key].bestCoupon
    })
  }
  return list
}
export const tryeToSpecFn = (allTyreSpec, tyres) => {
  let list = {}
  for (const tyre of allTyreSpec) {
    let vehicles = []
    for (const key in tyres) {
      let matchTyre = tyres[key].find(item => item.name === tyre)
      if (matchTyre) {
        vehicles.push(key)
      }
    }
    list[tyre] = vehicles
  }
  return list
}
export const getCurrentModelList = (classes, allModelList) => {
  return new Promise(resolve => {
    let list = []
    for (const model of allModelList) {
      let children = _.clone(model.children)
      let child = children.filter(item => classes.indexOf(item.value) >= 0)
      if (child.length) {
        model.children = child
        list.push(model)
      }
    }
    resolve(list)
  })
  // console.log(classes, allModelList)
}
export const getBestCoupon = (list, tyreList) => {
  let couponObjs = {}
  list.map(item => {
    item.coupon['applyTyres'] = item.applyTyres
    let typeList = couponObjs[item._type]
    if (typeList) {
      couponObjs[item._type].push(item)
    } else {
      couponObjs[item._type] = [item]
    }
  })
  let obj = {} //保存每一类优惠券的信息
  Object.keys(couponObjs).map(key => {
    let coupon = couponObjs[key][0]
    let obj1 = {}
    let count0 = couponObjs[key].length //当前优惠券的总张数
    let count1 = 0 //当前优惠券适用轮胎的购买张数
    let count2 = 0 //当前优惠券可用张数
    let applyTyres = coupon['applyTyres'] //当前优惠券适用轮胎
    tyreList.map(item => {
      item.id = String(item.id)
      if (applyTyres.indexOf(item.id) != -1) {
        count1 += item.count
      }
    })
    obj1 = { tyreCount: count1, couponCount: count0, useCount: count2 }
    obj[key] = obj1
  })
  // console.log(169, obj)
  //如果当前优惠券的满减数 > 适用的购买轮胎数，则此优惠券不能使用
  let useCouponObjs = {}
  let useCouponKeys = []
  // console.log('Object.keys(couponObjs)', Object.keys(couponObjs))
  Object.keys(couponObjs).map(key => {
    // console.log(175, key)
    let coupon = couponObjs[key][0]
    // console.log(177, coupon)
    let mjCount = coupon['rightContent']['fullNum'] //当前优惠券的满减数
    let ltCount = obj[key]['tyreCount']
    // console.log(mjCount, ltCount)
    if (mjCount <= ltCount) {
      useCouponObjs[key] = couponObjs[key]
      useCouponKeys.push(key)
    }
  })
  // console.log(182, useCouponKeys, useCouponObjs)
  let keyPriceObj = {}
  let keyPriceArr = []
  useCouponKeys.map(ucKey => {
    let price = 0
    let fullNum = 0
    let arr = [] //当前适用优惠券最多能用几张
    let tyreCount = obj[ucKey].tyreCount
    for (let i = 0; i < useCouponObjs[ucKey].length; i++) {
      let ucItem = useCouponObjs[ucKey][i]
      let rightContent = ucItem.rightContent
      fullNum += rightContent.fullNum
      if (fullNum <= tyreCount) {
        price += ucItem['rightContent']['subtractPrice']
        arr.push(ucItem)
      } else {
        break
      }
    }
    keyPriceObj[ucKey] = price
    keyPriceArr.push({ type: ucKey, price: price })
  })
  keyPriceArr.sort((a, b) => {
    return b.price - a.price
  })

  let couponObjsNew = {}
  if (keyPriceArr[0]) {
    let type = keyPriceArr[0]['type']
    couponObjsNew = { [type]: useCouponObjs[type] }
  }
  // console.log('couponObjsNew', couponObjsNew)
  return couponObjsNew
}
